var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3999 8.3996V21.4001H32.5999V8.3996M1.3999 8.3996H9.1999V12.2996H24.7989V8.3996H32.5999M1.3999 8.3996L6.6004 0.600098H27.3999L32.5999 8.3996",
    stroke: "#C4C4C4",
    strokeWidth: 1.04,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageBox);
export default __webpack_public_path__ + "static/media/storageBox.a953bf655509320b1cc7b9130d9bbab5.svg";
export { ForwardRef as ReactComponent };